<div
  [style.background-color]="model.backgroundColor || null"
  [ngClass]="{ 'banner-mobile': isMobileRender === true, 'model.theme': isMobileRender === false }"
>
  <div class="banner-content">
    <div class="banner__side banner__side-text">
      <app-contentful-renderer [model]="model.content"></app-contentful-renderer>
      <div class="buttons">
        <app-contentful-renderer [model]="model.button1"></app-contentful-renderer>
        <app-contentful-renderer [model]="model.button2"></app-contentful-renderer>
      </div>
    </div>
    <div class="banner__side banner__side-img">
      <app-contentful-renderer [model]="model.image"></app-contentful-renderer>
    </div>
  </div>
</div>
